import { useEffect, useState } from "react"
import { SubmitButton, MutateButton, GoButton } from "@imago/api-client-for-react"
import { WelcomeCall_ID } from "@imago/model"
import { useServiceAppointment, useTESTSetWelcomed } from "../../api.ts"
import { AppointmentView, BookingDialog, useBookService } from "../Book.tsx"
import { Hello } from "../Hello.tsx"

function BookWelcomeCall() {
	const bookWelcome = useBookService({serviceID: WelcomeCall_ID})

	return <section>
		<h2>Book a call</h2>
		<form>
			<p><strong>By booking a welcome call you hereby confirm that you have read our <a href="https://www.imago.tg/principles-and-values/">Principles & Values</a>, <a href="https://www.imago.tg/mission-and-vision/">Mission & Vision</a>, and the <a href="https://www.imago.tg/faq/">Frequently Asked Questions</a>.</strong></p>
			<p>Get to know us, share any doubts or concerns you might have, tell us your story, and start or continue your GAHT with Imago.</p>
			<SubmitButton mutation={bookWelcome} vars={data => {}}>Book a welcome call</SubmitButton>
		</form>
		<BookingDialog mutation={bookWelcome}/>
	</section>
}

export function Welcome({fullScreen}: {fullScreen?: boolean}) {
	const skip = useTESTSetWelcomed()

	const appointment = useServiceAppointment(WelcomeCall_ID)

	const [wasNotBooked, setWasNotBooked] = useState(false)
	useEffect(() => {
		if (appointment === null)
			setWasNotBooked(true)
	}, [appointment])

	if (appointment === undefined) return

	return (
		appointment ? (
			fullScreen ? (
				<main>
					<Hello/>
					<section>
						{wasNotBooked ? <h1>Thanks, see you!</h1> : <></>}
						{wasNotBooked ? <p>Confirmation was sent to your email address.</p> : <></>}
						<AppointmentView appointment={appointment} showTips={true}/>
					</section>
					<MutateButton className="secondary" mutation={skip}>TEST: Skip until after the welcome call</MutateButton>
				</main>
			) : (
				<div style={{marginBottom: '-33px'}}/>
			)
		) : (
			fullScreen ? (
				<main>
					<Hello>
						<p className="display-small">Welcome to Imago.</p>
					</Hello>
					<BookWelcomeCall/>
				</main>
			) : (
				<section>
					<h2>Welcome to Imago!</h2>
					<p>Want to start your Gender-Affirming Hormone Therapy at Imago?</p>
					<GoButton className="primary" href="/gaht">Book a Welcome call</GoButton>
				</section>
			)
		)
	)
}
